<label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
<span>
  <p-multiSelect
    #multi
    [class.bf-multiselect-readonly]="props.readonly"
    [options]="
      checkIfObservable(props.options) ? (props.options | async) : props.options
    "
    selectedItemsLabel="{0} items selected"
    [optionLabel]="props.labelProp"
    [optionValue]="props.valueProp"
    [maxSelectedLabels]="
      props.maxSelectedLabels ?? (props.display === 'chip' ? null : 1)
    "
    [formControl]="formControl"
    [formlyAttributes]="field"
    [placeholder]="props.placeholder"
    [filter]="props.filter ?? true"
    [filterPlaceHolder]="props.filterPlaceHolder ?? null"
    [filterBy]="props.filterBy ?? props.labelProp"
    [emptyFilterMessage]="props.emptyFilterMessage ?? null"
    [resetFilterOnHide]="props.resetFilterOnHide ?? false"
    [ariaFilterLabel]="props.ariaFilterLabel ?? null"
    [filterMatchMode]="props.filterMatchMode ?? 'contains'"
    [filterValue]="props.filterValue ?? null"
    [filterFields]="props.filterFields ?? [props.labelProp]"
    [appendTo]="props.appendTo ?? 'body'"
    [readonly]="props.readonly"
    [showClear]="props.showClear ?? false"
    [id]="field.id"
    [display]="props.display ?? 'comma'"
    [selectionLimit]="props.selectionLimit"
    (onChange)="props.onChange ? props.onChange(field, $event) : null"
    (onFilter)="props.onFilter ? props.onFilter(field, $event) : null"
    (onFocus)="props.onFocus ? props.onFocus(field, $event) : null"
    (onBlur)="props.onBlur ? props.onBlur(field, $event) : null"
    (onClick)="props.onClick ? props.onClick(field, $event) : null"
    (onClear)="props.onClear ? props.onClear(field, $event) : null"
    (onPanelShow)="props.onPanelShow ? props.onPanelShow(field, $event) : null"
    (onPanelHide)="props.onPanelHide ? props.onPanelHide(field, $event) : null"
    (onLazyLoad)="props.onLazyLoad ? props.onLazyLoad(field, $event) : null"
    (onRemove)="props.onRemove ? props.onRemove(field, $event) : null"
    (onSelectAllChange)="
      props.onSelectAllChange ? props.onSelectAllChange(field, $event) : null
    "
    (keydown)="props.keydown ?? onKeyDown($event)"
  >
    <ng-container *ngIf="props.setListItemsCustomText">
      <ng-template let-item pTemplate="item">
        <div
          class="b-f-multiselect-listitem basin-line-clamp-1"
          (mouseenter)="
            props.onListItemMouseEnter ? props.onListItemMouseEnter(item) : null
          "
          (mouseleave)="
            props.onListItemMouseLeave ? props.onListItemMouseLeave(item) : null
          "
        >
          {{ props.setListItemsCustomText(item) }}
        </div>
      </ng-template>
    </ng-container>
    <ng-template pTemplate="filter">
      <p-checkbox
        [binary]="true"
        [ngModel]="multi.allSelected()"
        (onChange)="multi.onToggleAll($event)"
        [disabled]="disabled"
        [ariaLabel]="toggleAllAriaLabel"
      ></p-checkbox>

      <div class="p-multiselect-filter-container">
        <basin-searchbox
          class="bf-multiselect-filter-searchbox"
          [searchString]="multi.filterValue"
          (searchStringChange)="
            multi.onFilterInputChange({ target: { value: $event } })
          "
          [placeholder]="props.filterPlaceholder ?? 'Search...'"
        ></basin-searchbox>
      </div>

      <button
        type="button"
        pButton
        icon="symbol-close"
        class="p-multiselect-close"
        (click)="multi.close($event)"
        [attr.aria-label]="'Close'"
      ></button>
    </ng-template>
  </p-multiSelect>
</span>
